import React from 'react';
import { AlertTriangle } from 'lucide-react';

const ConfirmModal = ({ isOpen, onConfirm, onCancel, title, message, confirmText = "Confirm", confirmColor = "red" }) => {
    if (!isOpen) return null;

    const buttonColors = {
        red: 'bg-rose-500 hover:bg-rose-600 text-white shadow-sm hover:shadow-rose-500/20',
        yellow: 'bg-amber-500 hover:bg-amber-600 text-white shadow-sm hover:shadow-amber-500/20',
    };

    const iconColors = {
        red: 'bg-rose-50 dark:bg-rose-500/15 text-rose-500',
        yellow: 'bg-amber-50 dark:bg-amber-500/15 text-amber-500',
    };

    return (
        <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4 animate-fade-in">
            <div className="bg-white dark:bg-[#111827] border border-slate-200 dark:border-slate-800 rounded-3xl shadow-2xl p-6 max-w-sm w-full animate-scale-in">
                <div className="flex items-start gap-4">
                    <div className={`w-11 h-11 rounded-2xl ${iconColors[confirmColor] || iconColors.red} flex items-center justify-center flex-shrink-0`}>
                        <AlertTriangle className="w-5 h-5" />
                    </div>
                    <div>
                        <h2 className="text-lg font-bold text-slate-900 dark:text-slate-100">{title}</h2>
                        <p className="text-sm text-slate-500 dark:text-slate-400 mt-1 leading-relaxed">{message}</p>
                    </div>
                </div>
                <div className="flex justify-end gap-3 mt-6">
                    <button
                        onClick={onCancel}
                        className="px-4 py-2.5 rounded-xl bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700/80 text-slate-700 dark:text-slate-300 text-sm font-semibold transition-colors"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className={`px-4 py-2.5 rounded-xl ${buttonColors[confirmColor] || buttonColors.red} text-sm font-semibold transition-all active:scale-[0.98]`}
                    >
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmModal;
